export default __webpack_public_path__ + "static/media/peq-box-flat.217221ae.svg";